import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Message from 'components/Message';
import { openModal } from 'components/Modal';
import { formatEmailSubjectDateTime } from 'helpers/intl-fns';
import { selectActiveVenue } from 'selectors/general';

import sharedMessages from './SkuOrder.messages';
import { emailOrderCustomer } from './SkuEmailOrderCustomer.saga';

const useEmailOrderCustomer = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { timezone: venueTimezone } = useSelector(selectActiveVenue);

  const openEmailCustomerModal = useCallback(
    ({ orderCreatedOn, venueName, userId, userName, orderId, surface }) => {
      const subjectValues = orderCreatedOn
        ? { ...formatEmailSubjectDateTime(orderCreatedOn, venueTimezone, intl), venueName }
        : { time: '', date: '', venueName: venueName || '' };

      const formattedSubject = intl.formatMessage(sharedMessages.emailModalSubject, subjectValues);

      dispatch(
        openModal('EmailModal', {
          onSubmit: (values, asyncFns) =>
            dispatch(emailOrderCustomer({ ...values, subjectValues, userName, orderId, surface }, asyncFns)),
          title: <Message message={sharedMessages.emailModalTitle} />,
          to: userName,
          subject: formattedSubject,
          initialValues: {
            message: '',
            recipients: [{ userId }],
          },
        })
      );
    },
    [dispatch, intl, venueTimezone]
  );

  return { openEmailCustomerModal };
};

export default useEmailOrderCustomer;
